import {GatewaySvc} from '../services/gateway.service';
import {TicketSvc}  from '../services/ticket.service';
import {EventBus} from "../utilities/event.bus";
import Ball from '../model/ball';
import GAME_CONFIG from '../data/gameConfig';

let roundStartingIn = 0;

 class Game {

    /** @constructor */

    constructor() {
        this.gameInfo = {
            roundNumber: 0,
            displayRoundNumber: '',
            startingIn: '',
            roundInProgress: false,
            countdownInterval: null,
            betsBlocked: false,
            isActive : true,
            countdown:false,
            spotNumber: 15,
            specialBets: {}
        };
    }

    showTicketUpdatedWarningModal() {
        GatewaySvc.getGatewaySvc().showDialog({
            message: TranslationSvc.getTranslation('betting_over'),
            id: 'payinModal',
            type: 'warning',
            delay: false,
            focus: true,
            showActions: true,
            actions: [
                {
                    key: '1',
                    text: 'Yes',
                    keyCode: [49, 81],
                    autoClose: true
                },
                {
                    key: '2',
                    text: 'No',
                    keyCode: [50, 82],
                    autoClose: true
                }
            ]
        });
    }

    /**
     * Loop trough odds and get only the ones from type 'spots'
     * @param {Array} odds
     */
    setSpotNumber(odds) {
        const initSpotNumber = this.spotNumber;
        this.spotNumber = initSpotNumber || 8;

        for (let i = 0; i < odds.length; i += 1) {
            if (odds[i].category === 'spots') {
                if (odds[i].type > this.spotNumber) {
                    this.spotNumber = odds[i].type;
                }
            }
        }

        if (this.spotNumber !== initSpotNumber) {
            EventBus.$emit('Keno.SpotNumberChanged');
        }
    }

    /**
     * Handle socket message
     * @param {Object} message
     */

    handleIncomingMessage (message) {
        let lastResult;

        if (message.data === null) return;

        if (message.type !== 'ticketUpdate') {
            this.gameInfo.betsBlocked = false;
        }
        switch(message.type){
            case 'game.deactivating':
                this.gameDeactivating = true;
                break;
            case 'game.deactivated':
                this._deactivateGame();
                break;
            case 'game.activated':
                this._activateGame();
                break;
            case 'state':
                this.gameInfo.roundNumber = message.data.eventId;
                this.gameInfo.displayRoundNumber = message.data.eventId;
                this.setSpotNumber(message.data.odds);
                this._setState(message.data,message.sentTime);
                break;
            case 'countdown':
                this.gameInfo.countdown = true;
                this.gameInfo.roundNumber = message.data.eventId;
                this.gameInfo.displayRoundNumber = message.data.eventId;
                this.gameInfo.roundInProgress = false;
                this.startRoundCountdown(message.data);
                break;
            case 'ball':
                this.gameInfo.roundInProgress = true;
                break;
            case 'new':
                EventBus.$emit('Keno.NewConfig');
                this.setSpotNumber(message.data.odds);
                this.gameInfo.countdown = false;
                this.gameInfo.roundNumber = message.data.eventId + 1;
                this.gameInfo.displayRoundNumber = message.data.eventId;
                this.gameInfo.roundInProgress = true;
                this._startNewRound(message);
                clearInterval(this.countdownInterval);
                break;
            case 'results':
                lastResult = message.data;
                break;
            case 'ticketUpdate':
                this._dispatchTicketUpdateMsg(message);
                break;
            case 'bettingDisabled':
                this.gameInfo.betsBlocked = true;
        }
    }

    /**
     * Update round on betslip
     * @param {Object} message
     * @private
     */

    _startNewRound(message){
        let ticket = TicketSvc.getTicketSvc().ticket;

        this.gameInfo.isActive = true;
        this.gameInfo.betsBlocked = false;

        if (ticket) {
            ticket.bets.forEach(bet => {
                let events = bet.event.toString().split('-');
                bet.event = events.length > 1 ? ((Number(events[0]) + 1) + '-' + (Number(events[1]) + 1)) : (Number(events[0]) + 1);
            });

            GatewaySvc.getGatewaySvc().sendMessage('Betslip.UpdateBets', {
                bets : ticket.bets,
                betslipId: 'Keno',
                ticket : 'single'
            });
        }
     }

    /**
     * Send message to master when ticket update event
     * @param {Object} message
     * @private
     */
    _dispatchTicketUpdateMsg(message) {
        let actionData = {
            game: 'Keno',
            message: `ticket:${message.data.action}Response`,
            ticketData: message.data
        };
        GatewaySvc.getGatewaySvc().sendMessage(actionData.message, actionData);
    }

    /**
     * Set all game balls
    */
    setBalls() {
        let balls = [],
            i;

        // create balls
        for (i = 1; i <= GAME_CONFIG.balls.count; i++) {
            balls.push(new Ball(i));
        }

        // add balls to game
        this.balls = balls;
    }

    /**
     * Activate balls
     * @param {Array}
     */
     activateBalls(numbers) {
        if (this.balls && numbers.length) {
             numbers.forEach( number => {
                this.balls.forEach(ball => {
                    if(ball.number == number){
                        ball.status = true;
                    }
               })
           })
       }
    }

    /**
    * Deactivate balls
    */
     dactivateBalls() {
        if (this.balls) {
            this.balls.forEach( ball => {
                ball.status = false;
             });
        }
      }

    /**
     * Deactivate game
     * @private
     */
    _deactivateGame() {
        this.gameInfo.isActive = false;
    }

    /**
     * Activate game
     * @private
     */
    _activateGame() {
        this.gameInfo.isActive = true;
    }

    /**
     * Set state info
     *  @param {Object} state
     *  @param {Object} stateTime
     */
    _setState(state, stateTime) {
        if (!state.eventId) {
            this.gameInfo.isActive = false;
        }

        this.gameInfo.countdownDuration  =  state.delay;

        if (state.type === 'countdown') {
            this.gameInfo.roundNumber = state.eventId;
            this.gameInfo.displayRoundNumber = state.eventId;
            let  commandTime = state.time;
            this.gameInfo.betsBlocked = false;
            this.gameInfo.countdown = true;
            this.gameInfo.startingIn = this.gameInfo.countdownDuration - Math.round((stateTime - commandTime) / 1000);
            roundStartingIn = this.gameInfo.startingIn;
            this.startCountdown();
        } else {
            this.gameInfo.roundNumber = state.eventId + 1;
            this.gameInfo.displayRoundNumber = state.eventId;
            this.gameInfo.roundInProgress = true;
        }
    }

    /** Set new round info
     *  @param {Object} data
     */
    startRoundCountdown(data) {
        this.gameInfo.countdownDuration = data.delay;
        this.gameInfo.roundNumber = data.eventId;
        this.gameInfo.displayRoundNumber = data.eventId;
        this.gameInfo.startingIn = this.gameInfo.countdownDuration;
        this.gameInfo.roundInProgress = false;
        this.gameInfo.countdown = true;
        roundStartingIn = this.gameInfo.startingIn;
        this.startCountdown();
    }

    /**
     * Start countdown
     */
    startCountdown() {
        if(this.countdownInterval){
            clearInterval(this.countdownInterval);
        }
        this.countdownInterval = setInterval(this.doCountdown.bind(this), 1000);
    }

    /**
     * Do countdown
     */
    doCountdown() {
        if (this.gameInfo.startingIn > 0) {
            --roundStartingIn;
            this.gameInfo.startingIn = roundStartingIn;
        }
    }
}

export default Game;



// WEBPACK FOOTER //
// game.js